import { render, staticRenderFns } from "./MaterialPatrolCard.vue?vue&type=template&id=5b4c8d36"
import script from "./MaterialPatrolCard.vue?vue&type=script&lang=js"
export * from "./MaterialPatrolCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialPatrolCard.vue?vue&type=style&index=0&id=5b4c8d36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports